import { FieldErrors, UseFormRegister } from "react-hook-form";
import Input from "../../../shared/input";
import { ISignUpUser } from "../../../interfaces/auth/ISignUpUser";
import Select from "../../../shared/select";

const SignupStep1 = ({
  register,
  errors,
}: {
  register: UseFormRegister<ISignUpUser>;
  errors: FieldErrors<ISignUpUser>;
}) => {
  return (
    <>
      <p className="text-[#0E0F0C] font-normal my-2 text-base">
        Main contact information
      </p>
      <Input
        containerStyle="mb-1"
        labelStyle="text-sm text-saloon-details"
        inputStyle="rounded-lg"
        placeholder=""
        label="Full name"
        register={register("fullName", {
          required: {
            message: "Full name is required",
            value: true,
          },
          validate: (value: string) =>
            !!value.trim() || "Full name is required",
        })}
        error={errors?.fullName?.message}
      />
      <Input
        containerStyle="mb-1"
        labelStyle="text-sm text-saloon-details"
        inputStyle="rounded-lg"
        placeholder=""
        label="Email Address"
        register={register("email", {
          required: {
            message: "Email Address is required",
            value: true,
          },
        })}
        error={errors?.email?.message}
      />
      <Input
        containerStyle="mb-1"
        labelStyle="text-sm text-saloon-details"
        inputStyle="rounded-lg"
        placeholder=""
        label="Phone Number"
        register={register("phoneNumber", {
          required: {
            message: "Phone Number is required",
            value: true,
          },
          validate: (value: string) =>
            !!value.trim() || "Phone Number is required",
        })}
        error={errors.phoneNumber?.message}
      />
      <Input
        containerStyle="mb-1"
        labelStyle="text-sm text-saloon-details"
        inputStyle="rounded-lg"
        placeholder=""
        label="Job Title"
        register={register("jobTitle", {
          required: {
            message: "Job Title is required",
            value: true,
          },
          validate: (value: string) =>
            !!value.trim() || "Job Title is required",
        })}
        error={errors.jobTitle?.message}
      />
      <p className="text-[#0E0F0C] font-normal my-2 text-base">
        Main contact information
      </p>
      <Input
        containerStyle="mb-1"
        labelStyle="text-sm text-saloon-details"
        inputStyle="rounded-lg"
        placeholder=""
        label="Hotel Name"
        register={register("hotelName", {
          required: {
            message: "Hotel name is required",
            value: true,
          },
          validate: (value: string) =>
            !!value.trim() || "Hotel name is required",
        })}
        error={errors.hotelName?.message}
      />
      <Input
        containerStyle="mb-1"
        labelStyle="text-sm text-saloon-details"
        inputStyle="rounded-lg"
        placeholder=""
        label="Country"
        register={register("country", {
          required: {
            message: "Country is required",
            value: true,
          },
          validate: (value: string) => !!value.trim() || "Country is required",
        })}
        error={errors.country?.message}
      />
      {/* <Input
		  containerStyle="mb-1"
		  labelStyle="text-sm text-saloon-details"
		  inputStyle="rounded-lg"
          placeholder=""
          label="Is it a single hotel or a franchise?"
          register={register("singleHotel", {
            required: {
              message: "Single Hotel or a franchise is required",
              value: true,
            },
            validate: (value: string) =>
              !!value.trim() || "Single Hotel or a franchise is required",
          })}
          error={errors.singleHotel?.message}	
        /> */}
      <label className={`block text-primary-light font-normal text-base mb-1`}>
        Role
      </label>
      <Select
        register={register("singleHotel", {
          required: {
            message: "Single Hotel or a franchise is required",
            value: true,
          },
          validate: (value: string) =>
            !!value.trim() || "Single Hotel or a franchise is required",
        })}
        error={errors.singleHotel?.message}
        placeholder="Is it a single hotel or a franchise?"
        containerStyle="mb-1 w-full"
        options={[
          {
            label: "Single",
            value: "single",
          },
          {
            label: "Franchise",
            value: "franchise",
          },
        ]}
      />
    </>
  );
};

export default SignupStep1;
